<template class="labelsheet">
    <v-container mt-0 pt-0>
      
    <v-card v-if="isErrorParam" flat outlined class="ma-5 pa-3">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">分析・診断サービス申し込み情報にアクセスできません</span>
      </div>
      <p class="caption">
        分析・診断サービス申し込み情報にアクセスできません。<br>
        <br>
        すでに削除されている申し込み情報を開こうとしているか、他の事業所の申し込み情報にアクセスしています。<br>
        もう一度お申込みページからアクセスしてください。<br>
      </p>
      <v-btn icon :to="{ path: '/' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>お申込みページに戻る
    </v-card>

    <div v-if="!isErrorParam" class="nonprint">
      <v-btn icon :to="returnPath">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="display-1 px-3">分析・診断サービス申込書（航空機）</span>
    </div>

    <v-card v-if="!isErrorParam" flat outlined class="pa-2 nonprint">
      <v-card-title class="mb-0 pa-1">
        <div class="subtitle-2 mb-0">
          <v-icon class="mr-1" color="primary">mdi-information-outline</v-icon>
          <span class="primary--text">送付していただく分析依頼品についてのお願い</span>
        </div>
      </v-card-title>
      <v-card-text class="mb-4 pb-2">
        <div class="title-1">
          OilMatrix専用ラベルシートに「お申込書」を印刷して弊社まで送付してください。<br>
          <br>
          （１）OilMatrix専用ラベルシートに<strong>お申込書</strong>を印刷してください。<br>
          （２）<strong>外箱貼付用ＱＲコード</strong>を外箱に貼付けてください。<br>
          （３）分析サンプルのボトルに、<strong>サンプルバーコード</strong>を貼り付けてください。<br>
          （４）シールを貼り付けた後の<strong>OilMatrix専用ラベルシートを分析依頼物に同梱して</strong>ください。
        </div>
      </v-card-text>

      <v-card-actions class="mt-0 pt-0">

<!--
      印刷するときに出てしまうので削除
      <v-tooltip top color="grey" activator="#ordersheet4LabelSheet_btn" class="nonprint">
        <span class="nonprint">OilMatrix専用ラベルシートに印刷します</span>
      </v-tooltip>
-->
        <v-row dense>
          <v-col cols=12 dense>
            <div class="title-1 pl-3 mb-0">
              OilMatrix専用ラベルシートをお持ちのお客様はこちらから印刷してください
            </div>
          </v-col>
          <v-col cols=12 dense>
            <v-btn 
              small 
              rounded 
              color="amber" 
              @click="barcodePrint()"
              class="ml-7 mt-0 mb-2"
              id="ordersheet4LabelSheet_btn"
              >
              <v-icon class="mr-2 ">mdi-printer</v-icon>
              お申込書を印刷する
            </v-btn>
          </v-col>
<!--
          <v-col cols=12 dense>
            <div class="subtitle-2 pl-3 mb-0">
              OilMatrix専用ラベルシートをお持ちでないお客様はこちらから印刷してください
            </div>
          </v-col>
          <v-col cols=12 dense>
            <v-btn 
              small 
              rounded 
              color="amber" 
                    class="ml-7 mt-0 mb-2"
              id="ordersheet_btn"
              :to="{ path: '/ordersheet', query: { id: this.applicationid }}"
              >
              <v-icon class="mr-2">mdi-file</v-icon>
              普通紙（A4）で印刷する
            </v-btn>
          </v-col>
-->
        </v-row>

<!--
      <v-tooltip top color="grey" activator="#ordersheet4lsF_btn"  class="nonprint">
        <span class="nonprint">普通紙にOilMatrix専用ラベルシートサイズの枠のみ印刷します</span>
      </v-tooltip>
      <v-btn 
        small 
        rounded 
        color="amber" 
        class="mx-3 mt-5"
        id="ordersheet4lsF_btn"
        :to="{ path: '/ordersheet4labelsheetFrame', query: { id: this.applicationid }}"
        >
        <v-icon class="mr-2">mdi-file</v-icon>
        OilMatrixOilMatrix専用ラベルシートで印刷する（枠のみ）
      </v-btn>
-->
<!--
      <p class="mx-3 mt-3 caption">
        ※ご利用の環境（OSやブラウザのバージョンやプリンターなど）によって印刷レイアウトが崩れる場合があります。印刷レイアウトが崩れる場合は、お手数ですが余白や印刷範囲を設定して印刷してください。
      </p>
-->
      </v-card-actions>


    </v-card>

<!--
    <div v-if="!isErrorParam" width="190mm" class="ma-0 pa-0">
-->
    <div v-if="!isErrorParam" class="outline ma-0 pa-0">

    <!-- Ａ 依頼書ヘッダ -->
    <v-simple-table  class="fixed_table ma-0 pa-0">
      <tbody>
        <tr>
          <td class="header_area ma-0 pa-0">

            <div class="header_title mb-1">ジャパン・アナリスト株式会社 分析・診断サービス申込書（同梱用）</div>
            <v-simple-table class="ml-2 header_table">
              <tr>
                <th class="header_th">
                  お申込み日
                </th>
                <td class="header_td">
                  {{ application.createdAt| moment('YYYY[年]MM[月]DD[日]') }}
                </td>

                <td class="header_qrcode" rowspan=4>

                  <vue-qrcode v-if="application.id" v-model="application.id" :width=65 :margin=1></vue-qrcode>

                </td>

                <td class="header_td" rowspan=4>
                  送付先<br>
                  〒252-0328 <br>
                  神奈川県相模原市南区麻溝台1-12-1 <br>
                  ジャパン・アナリスト株式会社<br>
                  TEL: 042-749-7512
                </td>
              </tr>
              <tr>
                <th class="header_th">
                  予約番号
                </th>
                <td class="header_td">
                  {{ application.id }}
                </td>
              </tr>
              <tr>
                <th class="header_th">
                  注文番号
                </th>
                <td class="header_td">
                  {{ application.CustomerOrderNumber }}
                </td>
              </tr>
              <tr>
                <th class="header_th">
                  分析サンプル数
                </th>
                <td class="header_td">
                  {{ application.SampleCount }} サンプル
                </td>
              </tr>

            </v-simple-table>

          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <!-- Ｂ 外箱貼り付け用ラベル -->
    <v-simple-table class="fixed_table ma-0 pa-0">
      <tbody>
        <tr>
          <template v-for="count of 3">
          <td class="box-sticker_area ma-0 pa-3" :key="count" v-if="count != 2">

            <div class="box-sticker_title">外箱貼付け用ＱＲコードシール</div>

            <v-simple-table class="box-sticker_table pa-2">
              <tr>
                <th class="box-sticker_th">
                  <div class="sticker_text">予約番号</div>
                </th>
                <td class="box-sticker_td">
                  <div class="sticker_text">{{ application.id }}</div>
                </td>
                <td class="box-sticker_qrcode" rowspan=4>

                  <vue-qrcode v-if="application.id" v-model="application.id" :width=55 :margin=1></vue-qrcode>

                </td>
              </tr>
              <tr>
                <th class="box-sticker_th">
                  <div class="sticker_text">お申込み日</div>
                </th>
                <td class="box-sticker_td">
                  <div class="sticker_text">{{ application.createdAt| moment('YYYY[年]MM[月]DD[日]') }}</div>
                </td>
              </tr>
              <tr>
                <th class="box-sticker_th">
                  <div class="sticker_text">分析サンプル数</div>
                </th>
                <td class="box-sticker_td">
                  <div class="sticker_text">{{ application.SampleCount }} サンプル</div>
                </td>
              </tr>
              <tr>
                <th class="box-sticker_th">
                  <div class="sticker_text">お申込者</div>
                </th>
                <td class="box-sticker_td">
                  <div class="sticker_text">
                    {{ application.OrdererCompanyName }}
                    <span v-if="application.OrdererOfficeName"><br>{{ application.OrdererOfficeName }} 様</span>
                    <span v-else> 様</span>
                  </div>
                </td>
              </tr>
            </v-simple-table>

          </td>

          <td class="center_space" :key="count" v-if="count == 2">
            <!-- 中央空白欄 -->
          </td>
<!--
            <td  class="box-sticker_area ma-0 pa-1">

            <div class="box-sticker_title">外箱貼付け用ＱＲコードシール</div>

            <v-simple-table class="box-sticker_table pa-1">
              <tr>
                <th class="box-sticker_th">
                  <div class="sticker_text">予約番号</div>
                </th>
                <td class="box-sticker_td">
                  <div class="sticker_text">{{ application.id }}</div>
                </td>
                <td class="box-sticker_qrcode" rowspan=4>

                  <vue-qrcode v-if="application.id" v-model="application.id" :width=55 :margin=1></vue-qrcode>

                </td>
              </tr>
              <tr>
                <th class="box-sticker_th">
                  <div class="sticker_text">お申込み日</div>
                </th>
                <td class="box-sticker_td">
                  <div class="sticker_text">{{ application.createdAt| moment('YYYY[年]MM[月]DD[日]') }}</div>
                </td>
              </tr>
              <tr>
                <th class="box-sticker_th">
                  <div class="sticker_text">分析サンプル数</div>
                </th>
                <td class="box-sticker_td">
                  <div class="sticker_text">{{ application.SampleCount }} サンプル</div>
                </td>
              </tr>
              <tr>
                <th class="box-sticker_th">
                  <div class="sticker_text">お申込者</div>
                </th>
                <td class="box-sticker_td">
                  <div class="sticker_text">
                    {{ application.PayCompany }}
                    <span v-if="application.PayOffice"><br>{{ application.PayOffice }} 様</span>
                    <span v-else> 様</span>
                  </div>
                </td>
              </tr>
            </v-simple-table>

          </td>
          -->
          </template>
        </tr>
      </tbody>
    </v-simple-table>

    <!-- Ｃ 報告書情報（送付先、宛名） -->
    <v-simple-table class="fixed_table ma-0 pa-0">
      <tbody>
        <tr>
          <td class="report_area ma-0 pa-0">

            <div class="report_title mb-2">納品明細書送付先</div>
            <v-simple-table class="report_table">
              <tr>
                <td class="report_td">
                  <div class="report_contents">
                    {{ payOffice.Zip }} {{ payOffice.Address1 }} {{ payOffice.Address2 }} {{ payOffice.Address3 }}<br>
                    {{ application.PayCompany }}<br>
                    <span v-if="application.PayOffice">{{ application.PayOffice }}<br></span>
                    {{ application.PayDept }} <span class="font-weight-bold">{{ application.PayPIC }}</span><span v-if="(application.PayPIC)"></span> 様<br>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="report_td">
                  <div class="report_contents mt-2 ml-2">
                    TEL: {{ payOffice.Tel }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="report_td">
                  <div class="report_contents ml-2">
                    FAX: {{ payOffice.FAX }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="report_td">
                  <div class="report_contents ml-2">
                    email:<span v-if="(payEmployee)">{{ payEmployee.email }}</span>
                  </div>
                </td>
              </tr>
            </v-simple-table>
          </td>

          <td  class="center_space ma-0 pa-0">
            <!-- 中央空白欄 -->
          </td>

          <td class="report_area ma-0 pa-0">

            <div class="report_title mb-2">報告書送付先</div>
            <v-simple-table class="report_table">
              <tr>
                <td class="report_td">
                  <div class="report_contents">
                    {{ delvOffice.Zip }} {{ delvOffice.Address1 }} {{ delvOffice.Address2 }} {{ delvOffice.Address3 }}<br>
                    {{ application.DelvCompany }}<br>
                    <span v-if="application.DelvOffice">{{ application.DelvOffice }}<br></span>
                    {{ application.DelvDept }} <span class="font-weight-bold">{{ application.DelvPIC }}</span><span v-if="(application.DelvPIC)"></span> 様<br>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="report_td">
                  <div class="report_contents mt-2 ml-2">
                    TEL: {{ delvOffice.Tel }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="report_td">
                  <div class="report_contents ml-2">
                    FAX: {{ delvOffice.FAX }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="report_td">
                  <div class="report_contents ml-2">
                    email:<span v-if="(delvEmployee)">{{ delvEmployee.email }}</span>
                  </div>
                </td>
              </tr>
            </v-simple-table>
          </td>
        </tr>

        <tr>
          <td class="box-sticker_area ma-0 pa-0" colspan=3>
            <div class="report_title mt-1 mb-1">報告書宛名</div>
            <v-simple-table class="report_table">
              <tr>
                <td class="box-sticker_td">
                  <div class="report_contents">
                    {{ application.RepCompany }}
                    <span v-if="application.RepOffice">{{ application.RepOffice }}</span> 
                    {{ application.RepDept }}
                    <span class="font-weight-bold">{{ application.RepPIC }}</span> <span v-if="(application.RepPIC)"> 様</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="box-sticker_td">
                  <div class="report_title mt-2 mb-1">納品明細書の送付方法：</div>
                  <div class="report_title mt-1 mb-1 ml-2">{{ application.Shipping }}</div>
                </td>
              </tr>
            </v-simple-table>
          </td>
         </tr>
      </tbody>
    </v-simple-table>

    <!-- Ｄ-1 サンプルヘッダ -->
    <div v-for="(item, index) of samples" v-bind:key="item.id">

      <v-simple-table class="fixed_table ma-0 pa-0 ma-0 pa-0">
        <tbody>
          <tr>
            <td class="sample_header_area ma-0 pa-0">

              <v-simple-table dense class="sample_header_table">
                <!-- D-1 サンプルヘッダ 見出し行 -->
                <tr>
                  <td class="sample_header_title sample_header_td" colspan=5>
                    <div class="sample_header_title_text2">
                        [ <b>{{ numSampleID(item.SampleID) }} </b>]
                        <template v-if="item.ParentCustomerMachineID">
                        {{ item.ParentCustomerMachineID }}／
                        </template>
                        {{ item.Name }}
                    </div>
                  </td>
                  <td class="sample_header_title sample_header_td2" colspan=2>
                      <div v-if="getOilNameLen(item) >= 10" class="sticker_text3"> {{ item.OilTypeText }} {{ item.OilPropertyText }}</div>
                      <div v-else class="sticker_text"> {{ item.OilTypeText }} {{ item.OilPropertyText }}</div>
                  </td>
                </tr>

                <!-- D-1 サンプルヘッダ 1行目 -->
                <tr>
                  <th class="sample_header_th">
                    <div class="sticker_text">[ <b>{{ numSampleID(item.SampleID) }} </b>]</div>
                  </th>
                  <td class="sample_header_td">
                    <div class="sticker_text"> 計 {{ item.Quantity }} mL／{{ item.BottleCount }} 本</div>
                  </td>
                  <th class="sample_header_th">
                    <div class="sticker_text">採取日</div>
                  </th>
                  <td class="sample_header_td">
                    <div class="sticker_text">{{ item.SamplingAt| moment('YYYY[年]MM[月]DD[日]') }}</div>
                  </td>
                  <th class="sample_header_th">
<!--
                    <div class="sticker_text">指定納期</div>
-->
                  </th>
                  <td class="sample_header_td">
<!--
                    <div class="sticker_text">
                      <span v-show="item.DeliveryPeriod">{{ item.DeliveryPeriod }}</span>
                      <span v-show="!item.DeliveryPeriod"></span>
                    </div>
-->
                  </td>
                  <td class="sample_header_qrcode" rowspan=5>
                    <vue-qrcode v-if="item.id" v-model="item.id" :width=65 :margin=0></vue-qrcode>
                  </td>
                </tr>
  
                <!-- D-1 サンプルヘッダ 2行目 -->
                <tr>
                  <th class="sample_header_th">
                    <div class="sticker_text">前回分析依頼番号</div>
                  </th>
                  <td class="sample_header_td">
                    <div class="sticker_text">{{ item.LatestOrderNumber }}</div>
                  </td>
                  <th class="sample_header_th">
                    <div class="sticker_text">
                      <v-icon x-small color="black" class="ml-1">mdi-air-filter</v-icon>
                      フィルター返却
                    </div>
                  </th>
                  <td class="sample_header_td">
                    <div class="sticker_text">{{getFilterString2(item.Filter)}}</div>
                  </td>
                  <th class="sample_header_th">
                    <div class="sticker_text">
                      <v-icon x-small color="black" class="ml-1">mdi-cube-send</v-icon>
                      サンプル返却
                    </div>
                  </th>
                  <td class="sample_header_td">
                    <div class="sticker_text">{{getSurplusString2(item.Surplus)}}</div>
                  </td>
                </tr>

                <!-- D-1 サンプルヘッダ 3行目 -->
                <tr>
                  <th class="sample_header_th">
                    <div class="sticker_text">分析セット</div>
                  </th>
                  <td class="sample_header_td" colspan="5">
                    <div class="sticker_text">{{item.AnalizeSetName}}</div>
                  </td>
                </tr>

                <!-- D-1 サンプルヘッダ 4行目 -->
                <tr>
                  <th class="sample_header_th">
                    <div class="sticker_text">分析項目</div>
                  </th>
                  <td class="sample_header_td" colspan="5">
                    <div class="sticker_text">
                      <div class="sticker_text">{{item.AnalizeItemNamesP}}</div>
                    </div>
                  </td>
                </tr>

                <!-- D-1 サンプルヘッダ 5行目 -->
                <tr>
                  <th class="sample_header_th">
                    <div class="sticker_text">オイル銘柄</div>
                  </th>
                  <td class="sample_header_td" colspan=3>
                    <div v-if="(item.OilmakerID.length + item.OilModelNumber.length) >= 65" class="sticker_text2"> {{ item.OilmakerID }}／{{ item.OilModelNumber }}</div>
                    <div v-else class="sticker_text"> {{ item.OilmakerID }}／{{ item.OilModelNumber }}</div>
                  </td>
                  <th class="sample_header_th">
                    <div class="sticker_text">
                      <v-icon x-small color="black" class="ml-1">mdi-fire-circle</v-icon>
                      危険物/取扱注意
                    </div>
                  </th>
                  <td class="sample_header_td">
                    <div v-if="item.isHazardousMaterials == '1'" class="sticker_text">あり</div>
                    <div v-else class="sticker_text">－</div>
                  </td>
                </tr>

                <!-- D-1 サンプルヘッダ 6行目 -->
                <tr>
                  <th class="sample_header_th">
                    <div class="sticker_text">COMPONENT</div>
                  </th>
                  <td class="sample_header_td">
                    <div class="sticker_text">{{ item.Equipment }}</div>
                  </td>
                  <th class="sample_header_th">
                    <div class="sticker_text">COMPONENT MODEL</div>
                  </th>
                  <td class="sample_header_td">
                    <div class="sticker_text">{{ item.ModelNumber }}</div>
                  </td>
                  <th class="sample_header_th">
                    <div class="sticker_text">POSITION</div>
                  </th>
                  <td class="sample_header_td">
                    <div class="sticker_text">{{ item.MountPosition }}</div>
                  </td>

                  <td class="sample_header_td" style="border-left: none; text-align: center">
                    {{item.id}}
                  </td>

                </tr>

                <!-- D-1 サンプルヘッダ 7行目 -->
                <tr>
                  <th class="sample_header_th">
                    <div class="sticker_text">AIRCRAFT T.T</div>
                  </th>
                  <td class="sample_header_td pr-1" align="right">
                    <div class="sticker_text">{{ item.ParentTotalOperatingTime }}</div>
                  </td>
                  <th class="sample_header_th">
                    <div class="sticker_text">AIRCRAFT TSO</div>
                  </th>
                  <td class="sample_header_td pr-1" align="right">
                    <div class="sticker_text">{{ item.ParentSinceOverhaulTime }}</div>
                  </td>
                  <th class="sample_header_th">
                    <div class="sticker_text"></div>
                  </th>
                  <td class="sample_header_td">
                  </td>
                  <td class="sample_header_qrcode" rowspan="3">
                    <v-icon small color="blue" class="ml-1" v-show="item.Filter != '001'">mdi-air-filter</v-icon>
                    <v-icon small color="green" class="ml-1" v-show="item.Surplus == '1'">mdi-cube-send</v-icon>
                    <v-icon small color="red" class="ml-1" v-show="item.Memo">mdi-alert-decagram</v-icon>
                    <v-icon small color="red" class="ml-1" v-show="item.isHazardousMaterials == '1'">mdi-fire-circle</v-icon>
                  </td>
                </tr>

                <!-- D-1 サンプルヘッダ 8行目 -->
                <tr>
                  <th class="sample_header_th">
                    <div class="sticker_text">SAMPLE T.T</div>
                  </th>
                  <td class="sample_header_td pr-1" align="right">
                    <div class="sticker_text">{{ item.TotalOperatingTime }}</div>
                  </td>
                  <th class="sample_header_th">
                    <div class="sticker_text">SAMPLE TSO</div>
                  </th>
                  <td class="sample_header_td pr-1" align="right">
                    <div class="sticker_text">{{ item.SinceOverhaulTime }}</div>
                  </td>
                  <td class="sample_header_td" colspan="2">
                  </td>
                </tr>

                <!-- D-1 サンプルヘッダ 9行目 -->
                <tr>
                  <th class="sample_header_th">
                    <div class="sticker_text">SAMPLE TSOD</div>
                  </th>
                  <td class="sample_header_td pr-1" align="right">
                    <div class="sticker_text">{{ item.OilUsageTime }}</div>
                  </td>
                  <th class="sample_header_th">
                    <div class="sticker_text">FIRTER T.T</div>
                  </th>
                  <td class="sample_header_td pr-1" align="right">
                    <div class="sticker_text">{{ item.FilterUsageTime }}</div>
                  </td>
                  <td class="sample_header_td" colspan="2">
                  </td>
                </tr>

                <!-- D-1 サンプルヘッダ 10行目 -->
                <tr>
                  <th class="sample_header_th">
                    <div class="sticker_text">
                      <v-icon x-small color="black" class="ml-1">mdi-alert-decagram</v-icon>
                      サンプルメモ
                    </div>
                  </th>
                  <td class="sample_header_td" colspan="6">
                    <div class="sticker_text">
                      {{item.Memo}}
                    </div>
                  </td>
                </tr>

              </v-simple-table>

            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <!-- D-2 サンプルボトル貼り付け用ラベル -->
      <v-simple-table class="fixed_table ma-0 pa-0">
        <tbody>
          <tr>
          <template v-for="count of 3">
            <td class="bottle_sticker_area ma-0 pa-1 pl-2" :key="count" v-if="count != 2"> 
              <!-- ボトル1本目 -->
              <v-simple-table class="bottle_sticker_table" v-if="count==1 || item.BottleCount > 1">
                <!-- D-2 サンプルボトル貼り付け用ラベル 1行目 -->
                <tr>
                  <th class="bottle_sticker_td" colspan=2>
                    <div v-if="count==1" class="sticker_text">[ {{numSampleID(item.SampleID)}} ] (1/{{item.BottleCount}}) {{application.PayCompany}}</div>
                    <div v-else class="sticker_text">[ {{numSampleID(item.SampleID)}} ] (2/{{item.BottleCount}}) {{application.PayCompany}}</div>
                  </th>
                  <td class="bottle_sticker_qrcode" rowspan=3>
                    <vue-qrcode v-if="item.id" v-model="item.id" :width=38 :margin=0></vue-qrcode>
                  </td>
                </tr>

                <!-- D-2 サンプルボトル貼り付け用ラベル 2行目 -->
                <tr>
                  <th class="bottle_sticker_td" colspan=2>
                    <div v-if="getOilNameLen(item) > 25" class="sticker_text3">{{ item.OilTypeText }} {{item.OilPropertyText}} ({{ item.Quantity }} mL)</div>
                    <div v-else-if="getOilNameLen(item) > 20" class="sticker_text2">{{ item.OilTypeText }} {{item.OilPropertyText}} ({{ item.Quantity }} mL)</div>
                    <div v-else class="sticker_text">{{ item.OilTypeText }} {{item.OilPropertyText}} ({{ item.Quantity }} mL)</div>
                  </th>
                </tr>

                <!-- D-2 サンプルボトル貼り付け用ラベル 3行目 -->
                <tr>
                  <td class="bottle_sticker_td" colspan=2>
<!--
                    <div v-if="(item.Name.length +  item.CustomerMachineID.length) > 80" class="sticker_text3">{{ item.Name }} {{ item.CustomerMachineID }} </div>
                    <div v-else-if="(item.Name.length +  item.CustomerMachineID.length) > 60" class="sticker_text2">{{ item.Name }} {{ item.CustomerMachineID }} </div>
                    <div v-else class="sticker_text">{{ item.Name }} {{ item.CustomerMachineID }} </div>
-->
                    <template v-if="item.ParentCustomerMachineID">
                      <div class="sticker_text">{{ item.ParentCustomerMachineID }}／{{ item.Name }}  </div>
                    </template>
                    <template v-else>
                      <div class="sticker_text">{{ item.Name }}  </div>
                    </template>

                  </td>
                </tr>

                <!-- D-2 サンプルボトル貼り付け用ラベル 4行目 -->
                <tr>
                  <td class="bottle_sticker_td" colspan=2>
                    <div v-if="item.SamplingAt" class="sticker_text">{{ item.SamplingAt| moment('YYYY[年]MM[月]DD[日]') }} 採油</div>
                    <div v-else>-</div>
                  </td>
<!--
                  <td class="bottle_sticker_td">
                    <div class="sticker_text">前回分析依頼番号</div>
                  </td>
                  <td class="bottle_sticker_td">
                    <div class="sticker_text">aaaaaaaaaaa</div>
                  </td>
-->
                  <td class="bottle_sticker_qrcode px-0" rowspan=2>
                    <v-icon x-small color="green" class="ma-0" v-show="item.Filter != '001'">mdi-air-filter</v-icon>
                    <v-icon x-small color="blue" class="ma-0" v-show="item.Surplus == '1'">mdi-cube-send</v-icon>
                    <v-icon x-small color="red" class="ma-0" v-show="item.Memo">mdi-alert-decagram</v-icon>
                    <v-icon x-small color="red" class="ma-0" v-show="item.isHazardousMaterials == '1'">mdi-fire-circle</v-icon>
                  </td>
                </tr>

                <!-- D-2 サンプルボトル貼り付け用ラベル 5行目 -->
                <tr>
                  <td class="bottle_sticker_td" colspan=2>
                    <div v-if="item.AnalizeSetNameP.length == 0" class="sticker_text"  style="color:white;">.</div>
                    <div v-else class="sticker_text">{{item.AnalizeSetNameP}}</div>
                  </td>
                </tr>

                <!-- D-2 サンプルボトル貼り付け用ラベル 6行目 -->
                <tr>
                  <td class="bottle_sticker_td" colspan=3>
                    <div class="sticker_text2">{{item.AnalizeItemsP}}</div>
                  </td>
                </tr>

                <!-- D-2 サンプルボトル貼り付け用ラベル 7行目 -->
<!--
                <tr>
                  <td class="bottle_sticker_td" colspan=3>
                    <div v-if="item.HazardousMaterialsDetail.length == 0" class="sticker_text3" style="color:white;">.</div>
                    <div v-else-if="item.HazardousMaterialsDetail.length >= 40" class="sticker_text3">{{item.HazardousMaterialsDetail}}</div>
                    <div v-else class="sticker_text">{{item.HazardousMaterialsDetail}}</div>
                  </td>
                </tr>
-->
                <!-- D-2 サンプルボトル貼り付け用ラベル 7行目 -->
                <tr>
                  <td class="bottle_sticker_td" colspan=3>
                    <div v-if="item.Memo.length == 0" class="sticker_text3" style="color:white;">.</div>
                    <div v-else-if="item.Memo.length >= 40" class="sticker_text3">{{item.Memo}}</div>
                    <div v-else class="sticker_text">{{item.Memo}}</div>
                  </td>
                </tr>

              </v-simple-table>
              <!-- ボトル1本目ここまで -->
            </td>

            <td class="center_space ma-0 pa-0" :key="count" v-if="count == 2">
              <!-- 中央空白欄 -->
            </td>

              <!-- ボトル2本目（2ボトル以上の場合のみ） -->
<!--
              <td  class="bottle_sticker_area ma-0 pa-0">
              <v-simple-table v-if="item.BottleCount > 1" class="bottle_sticker_table">
                <tr>
                  <th class="bottle_sticker_td" colspan=2>
                    <div class="sticker_text">[ {{numSampleID(item.SampleID)}} ] (1/{{item.BottleCount}}) {{application.PayCompany}}</div>
                  </th>
                  <td class="bottle_sticker_qrcode" rowspan=3>
                    <vue-qrcode v-if="item.id" v-model="item.id" :width=38 :margin=0></vue-qrcode>
                  </td>
                </tr>

                <tr>
                  <th class="bottle_sticker_td" colspan=2>
                    <div v-if="item.OilTypeText.length > 25" class="sticker_text3">{{ item.OilTypeText }} ({{ item.Quantity }} mL)</div>
                    <div v-else-if="item.OilTypeText.length > 20" class="sticker_text2">{{ item.OilTypeText }} ({{ item.Quantity }} mL)</div>
                    <div v-else class="sticker_text">{{ item.OilTypeText }} ({{ item.Quantity }} mL)</div>
                  </th>
                </tr>

                <tr>
                  <td class="bottle_sticker_td" colspan=2>
                    <div v-if="(item.Name.length +  item.CustomerMachineID.length) > 80" class="sticker_text3">{{ item.Name }} {{ item.CustomerMachineID }} </div>
                    <div v-else-if="(item.Name.length +  item.CustomerMachineID.length) > 60" class="sticker_text2">{{ item.Name }} {{ item.CustomerMachineID }} </div>
                    <div v-else class="sticker_text">{{ item.Name }} {{ item.CustomerMachineID }} </div>
                  </td>
                </tr>

                <tr>
                  <td class="bottle_sticker_td" colspan=2>
                    <div class="sticker_text">{{ item.SamplingAt| moment('YYYY[年]MM[月]DD[日]') }} 採油</div>
                  </td>
                  <td class="bottle_sticker_qrcode px-0" rowspan=2>
                    <v-icon x-small color="green" class="ma-0" v-show="item.Filter != '001'">mdi-air-filter</v-icon>
                    <v-icon x-small color="blue" class="ma-0" v-show="item.Surplus == '1'">mdi-cube-send</v-icon>
                    <v-icon x-small color="red" class="ma-0" v-show="item.Memo">mdi-alert-decagram</v-icon>
                    <v-icon x-small color="red" class="ma-0" v-show="item.isHazardousMaterials == '1'">mdi-fire-circle</v-icon>
                  </td>
                </tr>

                <tr>
                  <td class="bottle_sticker_td" colspan=2>
                    <div class="sticker_text">{{item.AnalizeSetNameP}}</div>
                  </td>
                </tr>

                <tr>
                  <td class="bottle_sticker_td" colspan=3>
                    <div class="sticker_text2">{{item.AnalizeItemsP}}</div>
                  </td>
                </tr>

                <tr>
                  <td class="bottle_sticker_td" colspan=3>
                    <div v-if="item.Memo.length >= 40" class="sticker_text3">{{item.Memo}}</div>
                    <div v-else class="sticker_text">{{item.Memo}}</div>
                  </td>
                </tr>
              </v-simple-table>
            </td>
-->
            <!-- ボトル2本目ここまで -->
          
          </template>
          </tr>

        </tbody>
      </v-simple-table>

      <div class="pagebreak" v-if="index==0&&application.SampleCount > 1"></div>
      <div class="pagebreak" v-if="index>0&&(index%3) == 0"></div>
    </div>

    <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
      <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
    </v-overlay>

    </div>
  </v-container>
</template>

<script>
import VueQrcode from 'vue-qrcode'
//import moment from 'moment'
import { API, graphqlOperation} from "aws-amplify"
import { getApplication, samplesByApplication } from '../graphql/queries'
import { officeByKey } from '../graphql/queries'
import { employeeByKey } from '../graphql/queries'
import utils  from '../utils/utils.js'
import mixin  from '../utils/mixin.js'

export default {
  components: {
    VueQrcode
  },
  mixins:[utils, mixin],
  head: {
    title: { inner: '分析依頼書'},
  },
  data: () => ({
    barcodeValue: '1234567890',
    applicationid: "",
    application: {},
    delvOffice: {},
    payOffice: {},
    delvEmployee: {},
    payEmployee: {},
    samples: [],
    sampleNum: 0,
    overlayStepper1: true,
    isErrorParam: false,
    ErrorInfo: "",
  }),
  mounted: async function () {
    this.applicationid = this.$route.query.id
    let application = await API.graphql(graphqlOperation(getApplication, {id: this.applicationid}))

      // 参照依頼情報のアクセスチェック
      // 存在しない依頼情報、他事業所の依頼情報を開いた場合はアクセス不正でエラーにする
      if(!application.data.getApplication) {
        this.isErrorParam = true
        this.ErrorInfo = "notExist"
        this.overlayStepper1 = false
        console.log('isErrorParam: ', this.isErrorParam)
        return
      }
      if(this.$store.state.isStaff == false) {
        if(application.data.getApplication.OfficeID != this.$store.state.operatingOffice.OfficeID) {
          this.isErrorParam = true
          this.ErrorInfo = "illegalAccess"
          this.overlayStepper1 = false
          console.log('isErrorParam: ', this.isErrorParam)
          return
        }
      }

    this.application = application.data.getApplication

    // samplesByApplicationクエリを使用してサンプル一覧を取得
    const samplesResult = await API.graphql(graphqlOperation(samplesByApplication, {ApplicationID: this.applicationid}))
    let _samples = samplesResult.data.samplesByApplication.items
    _samples.sort(function(a,b){
        if(a.SampleID < b.SampleID) return -1;
        if(a.SampleID > b.SampleID) return 1;
        return 0;
    });
//    this.samples = _samples

    let _delvOffice = await API.graphql(graphqlOperation(officeByKey, {OfficeID: this.application.DelvCompanyID + this.application.DelvOfficeID}))
    this.delvOffice = _delvOffice.data.officeByKey.items[0]

    let _payOffice = await API.graphql(graphqlOperation(officeByKey, {OfficeID: this.application.PayCompanyID + this.application.PayOfficeID}))
    this.payOffice = _payOffice.data.officeByKey.items[0]

    let _delvEmployee = await API.graphql(graphqlOperation(employeeByKey, {EmployeeID: this.application.DelvCompanyID + this.application.DelvOfficeID + this.application.DelvEmployeeID}))
    this.delvEmployee = _delvEmployee.data.employeeByKey.items[0]

    let _payEmployee = await API.graphql(graphqlOperation(employeeByKey, {EmployeeID: this.application.PayCompanyID + this.application.PayOfficeID + this.application.PayEmployeeID}))
    this.payEmployee = _payEmployee.data.employeeByKey.items[0]

    this.barcodeValue = this.applicationid
    this.sampleNum = this.samples.length

//    if (this.samples) {
//      this.samples.forEach((value, index) => {
    if (_samples) {
      for (const value of _samples) {
        console.log("sample:", value.id + " " + value.AnalizeType)
        console.log("sample:", value)
//        const analyseItemByType = this.$store.state.analizeItemList.filter(item => item.AnalizeType  == value.AnalizeType)
//        const analyseSetByType = this.$store.state.analizeSetList.filter(item => item.AnalizeType  == value.AnalizeType)
        let analizeSetList = await this.getAnalizeSetList(value.AnalizeType)
        let analizeItemList = await this.getAnalizeItemList(value.AnalizeType)
        let analizeItemSubList = await this.getAnalizeItemSubList(value.AnalizeType)

        var analyzeTypeNames = []
        var analyzeTypes = []
        var analizeSetName = ""

        // 見積で登録したサンプルのAnalizeItemSubは文字列（""で囲まれている）のでparseする
        // 通常（マイ機器、直接）のサンプルはオブジェクト（""で囲まれていない）のでparseしない
        let analizeItemSub = null
        if(value.AnalizeItemSub != undefined) {
          if(value.AnalizeItemSub.startsWith("\"")) {
            analizeItemSub = JSON.parse(JSON.parse(value.AnalizeItemSub))
            console.log("analizeItemSub(1):", analizeItemSub)
          }else {
            analizeItemSub = JSON.parse(value.AnalizeItemSub)
            console.log("analizeItemSub(2):", analizeItemSub)
          }
        }

        // setの分析項目名取得 value.AnalizeSet
        if (value.AnalizeSet) {
//          const analyseItemBySet = analyseSetByType[0].AnalizeSets.filter(item => item.Value  == value.AnalizeSet)
          let analizeSet = analizeSetList.filter(item => item.Value  == value.AnalizeSet)
          if(analizeSet) {
            analizeSetName = analizeSet[0].Text
            analyzeTypeNames = JSON.parse(analizeSet[0].AnalizeItemNames)
            analyzeTypes = JSON.parse(analizeSet[0].AnalizeItems)
            console.log("analizeSet:", analizeSetName + " " + analyzeTypes)
          }else {
            console.log("AnalizeSet not found:", value.id + " " + value.AnalizeSet)
          }

          // 追加元素が選択されている場合、setの分析項目に追加元素が選択されていないかを確認
          if(analizeItemSub) {
            for (const analizeItem of analyzeTypes) {
              let _analizeItemSub = analizeItemSub[analizeItem]

              // setの分析項目に対する追加元素が選択されている場合
              // setの分析項目の後ろに追加元素を印字
              if(_analizeItemSub) {
                console.log("have subItems:", analizeItem + " " + _analizeItemSub)
                let _analizeItemSubList = analizeItemSubList[analizeItem]
                for (const _analizeItem of _analizeItemSub) {
                  let item = _analizeItemSubList.filter(item => item.Value  == _analizeItem)
                  if(item[0]) {
                    analyzeTypeNames.push(item[0].Text)
                    analyzeTypes.push(item[0].Value)
                  }else {
                    analyzeTypeNames.push(analizeItem)
                    analyzeTypes.push(analizeItem)
                  }
                }
              }

            }
          }
        }

        // 個別の分析項目名取得
        var analizeItems = ''
        try {
          analizeItems = JSON.parse(value.AnalizeItems)
        } catch (e) {
          const replaced = value.AnalizeItems.replace(/'/g,"\"")
          analizeItems = JSON.parse(replaced)
        }

        if (analizeItems) {
          for (const analizeItem of analizeItems) {
            let item = analizeItemList.filter(item => item.Value  == analizeItem)
            if(item[0]) {
              analyzeTypeNames.push(item[0].Text)
              analyzeTypes.push(item[0].Value)
            }else {
              analyzeTypeNames.push(analizeItem)
              analyzeTypes.push(analizeItem)
            }

            // 追加元素が選択されている場合、個別の分析項目に追加元素が選択されていないかを確認
            if(analizeItemSub) {
              let _analizeItemSub = analizeItemSub[analizeItem]
              console.log("_analizeItemSub:", analizeItem + " is " + _analizeItemSub)
              // 個別の分析項目に対する追加元素が選択されている場合
              // 個別の分析項目の後ろに追加元素を印字
              if(_analizeItemSub) {
                let _analizeItemSubList = analizeItemSubList[analizeItem]
                for (const _analizeItem of _analizeItemSub) {
                  let item = _analizeItemSubList.filter(item => item.Value  == _analizeItem)
                  if(item[0]) {
                    analyzeTypeNames.push(item[0].Text)
                    analyzeTypes.push(item[0].Value)
                  }else {
                    analyzeTypeNames.push(analizeItem)
                    analyzeTypes.push(analizeItem)
                  }
                }
              }
            }
          }

/*          
          analizeJSON.forEach(valuem => {
            const analiseTypeName = analyseItemByType[0].AnalizeItems.filter(item => item.Value  == valuem)
            if(analiseTypeName[0]) {
              analyzeTypeNames.push(analiseTypeName[0].Text)
              analyzeTypes.push(analiseTypeName[0].Value)
            }else{ // 分析項目のデータがなくなった
              analyzeTypeNames.push(valuem)
            }
          })
*/
        }

        var _AnalizeItemNamesP = analyzeTypeNames.join(",")
        let nameLimit = 85
        if(_AnalizeItemNamesP.length > nameLimit) {
//           _samples[index].AnalizeItemNamesP =  _AnalizeItemNamesP.substr( 0, 169 ) + " ...（他、全" + analyzeTypeNames.length + "項目）";
          value.AnalizeItemNamesP = _AnalizeItemNamesP.substr( 0, nameLimit ) + " ...（他、全" + analyzeTypeNames.length + "項目）";
        }else {
//          _samples[index].AnalizeItemNamesP = analyzeTypeNames.join(",")
          value.AnalizeItemNamesP = analyzeTypeNames.join(",")
        }
        
        var _AnalizeItemsP = analyzeTypes.join(",")
        let codeLimit = 167
        if(_AnalizeItemsP.length > codeLimit) {
//           _samples[index].AnalizeItemsP =  _AnalizeItemsP.substr( 0, 167) + " ...（他、全" + analyzeTypes.length + "項目）";
           value.AnalizeItemsP =  _AnalizeItemsP.substr( 0, codeLimit) + " ...（他、全" + analyzeTypes.length + "項目）";
        }else {
//          _samples[index].AnalizeItemsP = analyzeTypes.join(",")
          value.AnalizeItemsP = analyzeTypes.join(",")
         
        }

//        _samples[index].AnalizeSetNameP = analizeSetName
        value.AnalizeSetNameP = analizeSetName
      }
    }
    this.samples = _samples
    console.log('samples', this.samples)
    this.overlayStepper1 = false    
  },
  computed: {
    returnPath() {
      return { path: '/ReferApplication', query: { id: this.applicationid }}
    }
  },
  methods: {
    numSampleID (sampleid) {
      return ( '000' + Number(sampleid) ).slice( -3 );
    },
    getOilNameLen: async function(item) {
      let length = 0
      length = item.OilTypeText.length
      if(item.OilPropertyText) {
        length += item.OilPropertyText.length
      }
      return length
    },
    barcodePrint: async function () {
      // window.document.body.innerHTML = document.getElementById(
      //   'printable'
      // ).innerHTML     
      window.print()
/*
window.print({margins:{marginType:"default"}},
        (success, error) => {
            if(success){
                console.log('Print successfully.');
            }else{
                console.log(error);
            }
        });
 */
 
      // this.$router.go({path: this.$router.currentRoute.path, force: true})
      // this.$router.push('/mymachine')
      // this.$router.push("/mymachinelist");
      // window.location.reload();
    },

  },

//  filters: {
//   moment: function (date) {
//        return moment(date).format('YYYY/MM/DD HH:mm');// eslint-disable-line
//    }
//  }
}
</script>


<style scoped lang="scss">

  .onlyprint { 
    display: none;
  }

  .outline {
    width: 70%;
  }

  .header_area {
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 0mm;
    width: 190.0mm;
    height: 50.0mm;
//    border: 1px solid;
    border:none !important;
  }

  .header_title {
    font-size : 18px !important;
    font-weight:bold;
  }

  .header_table {
    border:none !important;
  }

  .header_th {
//    width: 30mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .header_td {
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .header_qrcode {
    width: 50mm;
    height: 0px;
    padding: auto;
    text-align: center;
//    border: 1px solid;
    border:none !important;
  }


  .box-sticker_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸90mm
    height: 40.0mm;   //原寸40mm
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_title {
    font-size : 12px !important;
  }

  .box-sticker_table {
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_th {
    font-size : 9px !important;
    width: 20mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_td {
    font-size : 9px !important;
//    width: 30mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_qrcode {
//    width: 20mm;
    height: 0px;
    padding: auto;
    text-align: center;
//    border: 1px solid;
    border:none !important;
  }


  .report_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸 90mm
    height: 50.0mm;   //原寸50mm
//    border: 1px solid;
    border:none !important;
  }

  .report_title {
    font-size : 12px !important;
  }

  .report_table {
//    border: 1px solid;
    border:none !important;
  }

  .report_td {
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .report_contents {
    padding: 0mm;
    font-size : 11px !important;
  }



  .sample_header_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 0mm;
    width:  190.0mm; // 原寸190
    height:  50.0mm; // 原寸50
//    border: 1px solid;
    border:none !important;
  }

  .sample_header_title {
    font-size : 10px !important;
    font-weight: bold;
    color: #ffffff;
    background-color: rgb(61, 57, 57);
    width: 100%;
    padding-left: 2mm;
  }

  .sample_header_title_text2 {
    width: 130%;
    font-size: 10px;
    -webkit-transform:scale(0.80);
    -moz-transform:scale(0.80);
    -ms-transform:scale(0.80);
    -o-transform:scale(0.80);
    transform:scale(0.80);
    transform-origin: left center;
  }

  .sample_header_table {
//    border: 1px solid;
    border:none !important;
  }

  .sample_header_th {
    font-size : 5px !important;
    width: 28mm;
    height: 0px;
    padding: 0mm;
    padding-left: 1mm;
    border-bottom: 1px solid;
    border-left: 1px solid;
    border-left-color:lightgray
  }

.sample_header_td {
    font-size : 5px !important;
    width: 25mm;
    height: 0px;
    padding: 0mm;
    padding-left: 1mm;
    border-bottom: 1px solid;
    border-left: 1px solid;
    border-left-color:lightgray
  }

  .sample_header_td2 {
    font-size : 6px !important;
    width: 30mm;
    height: 0px;
    padding: 0mm;
    padding-left: 1mm;
    box-sizing: border-box;
    border-bottom: 1px solid;
  }

  .sample_header_qrcode {
    width: 30mm;
    height: 0px;
    padding: auto;
    text-align: center;
//    border: 1px solid;
    border:none !important;
  }

  .bottle_sticker_area {
//    font-family: serif;
    font-size : 5px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸90mm
    height: 40.0mm; //原寸40mm
//    border: 1px solid;
    border:none !important;
  }

  .bottle_sticker_table {
    table-layout: fixed;
//    border: 1px solid;
    border:none !important;
  }


  .bottle_sticker_th {
    font-size : 5px !important;
    width: 20mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
//    border:none !important;
    border-bottom: 1px solid;
  }

  .bottle_sticker_td {
    font-size : 5px !important;
    word-break : break-all;
//    width: 40mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
//    border:none !important;
    border-bottom: 1px solid;
}

  .sticker_text {
    width: 100%;
  }

  .sticker_text2 {
    width: 100%;
  }

  .sticker_text3 {
    width: 100%;
  }

  .bottle_sticker_qrcode {
  //    width: 20mm;
      height: 0px;
      padding: auto;
      text-align: center;
      vertical-align: middle;
//    border: 1px solid;
    border:none !important;
    }

  .center_space {
    width: 10mm;
    padding: 0mm;
    margin: 0px !important;
//    border: 1px solid;
    border:none !important;
  }

  .pagebreak {
    break-after: page;
  }

  @page labelsheet{
    size: A4 portrait; // 横の場合はlandscape

    margin-top:    17.0mm; //原寸17mm
    margin-bottom: 10.0mm; //原寸10mm

    margin-left:   10.0mm; //原寸10mm
    margin-right:  10.0mm; //原寸10mm
  }

  @media print {
    .v-application body {
      padding: 0 !important;
    }

    .v-application .fixed_table {
      display: table !important;
      table-layout: fixed !important;
    }

    .v-application .outline {
      width: 100% !important;
    }

    .v-application .header_area {
      font-size : 12px !important;
      text-align: left !important;
      vertical-align: top !important;
      padding: 0mm !important;
      width: 190.0mm !important;
      height: 50.0mm !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .header_title {
      font-size : 18px !important;
      font-weight:bold !important;
    }

    .v-application .header_table {
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .header_th {
      height: 0px !important;
      padding: 0mm !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .header_td {
      height: 0px !important;
      padding: 0mm !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .header_qrcode {
      height: 0px !important;
      padding: auto !important;
      text-align: center !important;
      box-sizing: border-box !important;
      border:none !important;
    }


    .v-application .box-sticker_area {
      font-size : 12px !important;
      text-align: left !important;
      vertical-align: top !important;
      width:  90.0mm !important;
      height: 40.0mm !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .box-sticker_title {
      font-size : 12px !important;
    }

    .v-application .box-sticker_table {
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .box-sticker_th {
      font-size : 9px !important;
      width: 20mm !important;
      height: 0px !important;
      padding: 0mm !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .box-sticker_td {
      font-size : 9px !important;
      height: 0px !important;
      padding: 0mm !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .box-sticker_qrcode {
      height: 0px !important;
      padding: auto !important;
      text-align: center !important;
      box-sizing: border-box !important;
      border:none !important;
    }


    .v-application .report_area {
      font-size : 12px !important;
      text-align: left !important;
      vertical-align: top !important;
      padding: 1mm !important;
      width:  90.0mm !important;
      height: 50.0mm !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .report_title {
      font-size : 12px !important;
    }

    .v-application .report_table {
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .report_td {
      height: 0px !important;
      padding: 0mm !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .report_contents {
      padding: 0mm !important;
      font-size : 11px !important;
    }

    .v-application .sample_header_area {
      font-size : 12px !important;
      text-align: left !important;
      vertical-align: top !important;
      padding: 0mm !important;
      width: 190.0mm !important;
      height: 50.0mm !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .sample_header_title {
      font-weight: bold !important;
      color: #ffffff !important;
      background-color: rgb(61, 57, 57) !important;
      -webkit-print-color-adjust: exact !important;
      width: 100% !important;
      padding-left: 2mm !important;
    }

    .v-application .sample_header_title_text2 {
      width: 130% !important;
      font-size: 10px !important;
      -webkit-transform:scale(0.80) !important;
      -moz-transform:scale(0.80) !important;
      -ms-transform:scale(0.80) !important;
      -o-transform:scale(0.80) !important;
      transform:scale(0.80) !important;
      transform-origin: left center !important;
    }

    .v-application .sample_header_table {
      box-sizing: border-box !important;
      border:none !important;
    }


    .v-application .sample_header_th {
      font-size : 6px !important;
      width: 28mm !important;
      height: 0px !important;
      padding: 0mm !important;
      padding-left: 1mm !important;
      box-sizing: border-box !important;
      border-bottom: 1px solid !important;
      border-left: 1px solid !important;
      border-left-color:lightgray !important;
    }

    .v-application .sample_header_td {
      font-size : 6px !important;
      width: 25mm !important;
      height: 0px !important;
      padding: 0mm !important;
      padding-left: 1mm !important;
      box-sizing: border-box !important;
      border-bottom: 1px solid !important;
      border-left: 1px solid !important;
      border-left-color:lightgray !important;
    }

    .v-application .sample_header_td2 {
      font-size : 6px !important;
      width: 30mm !important;
      height: 0px !important;
      padding: 0mm !important;
      padding-left: 1mm !important;
      box-sizing: border-box !important;
      border-bottom: 1px solid !important;
    }

    .v-application .sample_header_qrcode {
      width: 30mm !important;
      height: 0px !important;
      padding: auto !important;
      text-align: center !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .bottle_sticker_area {
      font-size : 5px !important;
      text-align: left !important;
      vertical-align: top !important;
      padding: 0mm !important;
      width:  90.0mm !important;
      height: 40.0mm !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .bottle_sticker_table {
      table-layout: fixed !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .bottle_sticker_th {
      font-size : 5px !important;
      width: 35mm !important;
      height: 0px !important;
      padding: 0mm 0mm 0mm 0mm !important;
      box-sizing: border-box !important;
      border-bottom: 1px solid !important;
    }

    .v-application .bottle_sticker_td {
      font-size : 5px !important;
      word-break : break-all !important;
      width: 37mm !important;
      height: 0px !important;
      padding: 0mm 0mm 0mm 0mm !important;
      box-sizing: border-box !important;
      border-bottom: 1px solid !important;
    }

    .v-application .sticker_text {
      width: 120% !important;
      font-size: 10px !important;
      -webkit-transform:scale(0.8) !important;
      -moz-transform:scale(0.8) !important;
      -ms-transform:scale(0.8) !important;
      -o-transform:scale(0.8) !important;
      transform:scale(0.8) !important;
      transform-origin: left center !important;
    }

    .v-application .sticker_text2 {
      width: 175% !important;
      font-size: 10px !important;
      -webkit-transform:scale(0.56) !important;
      -moz-transform:scale(0.56) !important;
      -ms-transform:scale(0.56) !important;
      -o-transform:scale(0.56) !important;
      transform:scale(0.56) !important;
      transform-origin: left center !important;
    }

    .v-application .sticker_text3 {
      width: 183% !important;
      font-size: 10px !important;
      -webkit-transform:scale(0.53) !important;
      -moz-transform:scale(0.53) !important;
      -ms-transform:scale(0.53) !important;
      -o-transform:scale(0.53) !important;
      transform:scale(0.53) !important;
      transform-origin: left center !important;
    }

    .v-application .bottle_sticker_qrcode {
      width: 20mm !important;
      height: 0px !important;
      padding: auto !important;
      text-align: center !important;
      vertical-align: middle !important;
      box-sizing: border-box !important;
      border:none !important;
    }



    .v-application .center_space {
      width: 10.0mm !important;
      padding: 0mm !important;
      margin: 0px !important;
      box-sizing: border-box !important;
      border:none !important;
    }

    .v-application .pagebreak {
      break-after: page !important;
    }

    .v-application .nonprint { 
      display: none !important;
    }

    .v-application .onlyprint { 
      display: block !important;
    }
  }
</style>

<!--
<style scoped lang="scss">

  .onlyprint { 
    display: none;
  }

  .outline {
    width: 70%;
  }

  .header_area {
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 0mm;
    width: 190.0mm;
    height: 50.0mm;
//    border: 1px solid;
    border:none !important;
  }

  .header_title {
    font-size : 18px !important;
    font-weight:bold;
  }

  .header_table {
    border:none !important;
  }

  .header_th {
//    width: 30mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .header_td {
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .header_qrcode {
    width: 50mm;
    height: 0px;
    padding: auto;
    text-align: center;
//    border: 1px solid;
    border:none !important;
  }


  .box-sticker_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸90mm
    height: 40.0mm;   //原寸40mm
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_title {
    font-size : 12px !important;
    font-weight: bold;
  }

  .box-sticker_table {
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_th {
    font-size : 9px !important;
    width: 20mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_td {
    font-size : 9px !important;
//    width: 30mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_qrcode {
//    width: 20mm;
    height: 0px;
    padding: auto;
    text-align: center;
//    border: 1px solid;
    border:none !important;
  }


  .report_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸 90mm
    height: 50.0mm;   //原寸50mm
//    border: 1px solid;
    border:none !important;
  }

  .report_title {
    font-size : 12px !important;
  }

  .report_table {
//    border: 1px solid;
    border:none !important;
  }

  .report_td {
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .report_contents {
    padding: 0mm;
    font-size : 11px !important;
  }



  .sample_header_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 0mm;
    width:  190.0mm; // 原寸190
    height:  50.0mm; // 原寸50
//    border: 1px solid;
    border:none !important;
  }

  .sample_header_title {
    font-size : 10px !important;
    font-weight: bold;
    color: #ffffff;
    background-color: rgb(61, 57, 57);
    width: 100%;
    padding-left: 2mm;
  }

  .sample_header_title_text2 {
    width: 130%;
    font-size: 10px;
    -webkit-transform:scale(0.80);
    -moz-transform:scale(0.80);
    -ms-transform:scale(0.80);
    -o-transform:scale(0.80);
    transform:scale(0.80);
    transform-origin: left center;
  }

  .sample_header_table {
//    border: 1px solid;
    border:none !important;
  }

  .sample_header_th {
    font-size : 5px !important;
    width: 28mm;
    height: 0px;
    padding: 0mm;
    padding-left: 1mm;
    border-bottom: 1px solid;
    border-left: 1px solid;
    border-left-color:lightgray
  }

.sample_header_td {
    font-size : 5px !important;
    width: 25mm;
    height: 0px;
    padding: 0mm;
    padding-left: 1mm;
    border-bottom: 1px solid;
    border-left: 1px solid;
    border-left-color:lightgray
  }

  .sample_header_td2 {
    font-size : 6px !important;
    width: 30mm;
    height: 0px;
    padding: 0mm;
    padding-left: 1mm;
    box-sizing: border-box;
    border-bottom: 1px solid;
  }

  .sample_header_qrcode {
    width: 30mm;
    height: 0px;
    padding: auto;
    text-align: center;
//    border: 1px solid;
    border:none !important;
  }

  .bottle_sticker_area {
//    font-family: serif;
    font-size : 5px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸90mm
    height: 40.0mm; //原寸40mm
//    border: 1px solid;
    border:none !important;
  }

  .bottle_sticker_table {
    table-layout: fixed;
//    border: 1px solid;
    border:none !important;
  }


  .bottle_sticker_th {
    font-size : 5px !important;
    width: 20mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
//    border:none !important;
    border-bottom: 1px solid;
  }

  .bottle_sticker_td {
    font-size : 5px !important;
    word-break : break-all;
//    width: 40mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
//    border:none !important;
    border-bottom: 1px solid;
}

  .sticker_text {
    width: 100%;
  }

  .sticker_text2 {
    width: 100%;
  }

  .sticker_text3 {
    width: 100%;
  }

  .bottle_sticker_qrcode {
  //    width: 20mm;
      height: 0px;
      padding: auto;
      text-align: center;
      vertical-align: middle;
//    border: 1px solid;
    border:none !important;
    }

  .center_space {
    width: 10mm;
    padding: 0mm;
    margin: 0px !important;
//    border: 1px solid;
    border:none !important;
  }

  .pagebreak {
    break-after: page;
  }

  @page labelsheet{
    size: A4 portrait; // 横の場合はlandscape

    margin-top:    17.0mm; //原寸17mm
    margin-bottom: 10.0mm; //原寸10mm

    margin-left:   10.0mm; //原寸10mm
    margin-right:  10.0mm; //原寸10mm
  }

  @media print {
  /*
    .page {
      width: 190mm;
      height: 269mm;
      page-break-after: always;

      box-sizing: border-box;
    //    padding: 20mm 25mm;
    //    font-size: 11pt;
    }
  */

    body {
      padding: 0;
  //    height: 269.5mm; // A4サイズ
  //    width: 189.5mm; // needed for Chrome
    }

    .fixed_table {
      display: table !important;
      table-layout: fixed;
    }

    .outline {
      width: 100%;
    }

    .header_area {
      font-size : 12px !important;
      text-align: left;
      vertical-align: top;
      padding: 0mm;
      width: 190.0mm;
      height: 50.0mm;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .header_title {
      font-size : 18px !important;
      font-weight:bold;
    }

    .header_table {
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .header_th {
  //    width: 30mm;
      height: 0px;
      padding: 0mm;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .header_td {
      height: 0px;
      padding: 0mm;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .header_qrcode {
  //    width: 20mm;
      height: 0px;
      padding: auto;
      text-align: center;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }


    .box-sticker_area {
  //    font-family: serif;
      font-size : 12px !important;
      text-align: left;
      vertical-align: top;
      width:  90.0mm; //原寸90mm
      height: 40.0mm;   //原寸40mm
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .box-sticker_title {
      font-size : 12px !important;
      font-weight: bold;
    }

    .box-sticker_table {
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .box-sticker_th {
      font-size : 9px !important;
      width: 20mm;
      height: 0px;
      padding: 0mm;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .box-sticker_td {
      font-size : 9px !important;
  //    width: 30mm;
      height: 0px;
      padding: 0mm;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .box-sticker_qrcode {
  //    width: 20mm;
      height: 0px;
      padding: auto;
      text-align: center;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }


    .report_area {
  //    font-family: serif;
      font-size : 12px !important;
      text-align: left;
      vertical-align: top;
      padding: 1mm;
      width:  90.0mm; //原寸 90mm
      height: 50.0mm;   //原寸50mm
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .report_title {
      font-size : 12px !important;
    }

    .report_table {
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .report_td {
      height: 0px;
      padding: 0mm;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .report_contents {
      padding: 0mm;
      font-size : 11px !important;
    }

    .sample_header_area {
  //    font-family: serif;
      font-size : 12px !important;
      text-align: left;
      vertical-align: top;
      padding: 0mm;
      width: 190.0mm; // 原寸190
      height: 50.0mm; // 原寸50
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .sample_header_title {
  //    font-size : 9px !important;
      font-weight: bold;
      color: #ffffff;
      background-color: rgb(61, 57, 57) !important;
      -webkit-print-color-adjust: exact;
      width: 100%;
      padding-left: 2mm;
    }

    .sample_header_title_text2 {
      width: 130%;
      font-size: 10px;
      -webkit-transform:scale(0.80);
      -moz-transform:scale(0.80);
      -ms-transform:scale(0.80);
      -o-transform:scale(0.80);
      transform:scale(0.80);
      transform-origin: left center;
    }

    .sample_header_table {
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }


    .sample_header_th {
      font-size : 6px !important;
      width: 28mm;
      height: 0px;
      padding: 0mm;
      padding-left: 1mm;
      box-sizing: border-box;
      border-bottom: 1px solid;
      border-left: 1px solid;
      border-left-color:lightgray
    }

    .sample_header_td {
      font-size : 6px !important;
      width: 25mm;
      height: 0px;
      padding: 0mm;
      padding-left: 1mm;
      box-sizing: border-box;
      border-bottom: 1px solid;
      border-left: 1px solid;
      border-left-color:lightgray
    }

    .sample_header_td2 {
      font-size : 6px !important;
      width: 30mm;
      height: 0px;
      padding: 0mm;
      padding-left: 1mm;
      box-sizing: border-box;
      border-bottom: 1px solid;
    }

    .sample_header_qrcode {
      width: 30mm;
      height: 0px;
      padding: auto;
      text-align: center;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .bottle_sticker_area {
  //    font-family: serif;
      font-size : 5px !important;
      text-align: left;
      vertical-align: top;
      padding: 0mm;
      width:  90.0mm; //原寸90mm
      height: 40.0mm; //原寸40mm
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .bottle_sticker_table {
      table-layout: fixed;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }


    .bottle_sticker_th {
      font-size : 5px !important;
      width: 35mm;
      height: 0px;
      padding: 0mm 0mm 0mm 0mm;
      box-sizing: border-box;
  //    border: 1px solid;
  //    border:none !important;
      border-bottom: 1px solid;
    }

    .bottle_sticker_td {
      font-size : 5px !important;
      word-break : break-all;
      width: 37mm;
      height: 0px;
      padding: 0mm 0mm 0mm 0mm;
      box-sizing: border-box;
  //    border: 1px solid;
  //    border:none !important;
      border-bottom: 1px solid;
    }

    .sticker_text {
      width: 120%;
      font-size: 10px;
      -webkit-transform:scale(0.8);
      -moz-transform:scale(0.8);
      -ms-transform:scale(0.8);
      -o-transform:scale(0.8);
      transform:scale(0.8);
      transform-origin: left center;
    }

    .sticker_text2 {
//      width: 150%;
      width: 175%;
      font-size: 10px;
      -webkit-transform:scale(0.56); //0.6
      -moz-transform:scale(0.56);
      -ms-transform:scale(0.56);
      -o-transform:scale(0.56);
      transform:scale(0.56);
      transform-origin: left center;
    }

    .sticker_text3 {
      width: 183%;
//      width: 175%;
      font-size: 10px;
      -webkit-transform:scale(0.53); //0.55
      -moz-transform:scale(0.53);
      -ms-transform:scale(0.53);
      -o-transform:scale(0.53);
      transform:scale3d(0.53);
      transform:scale(0.53);
      transform-origin: left center;
    }

    .bottle_sticker_qrcode {
      width: 20mm;
      height: 0px;
      padding: auto;
      text-align: center;
      vertical-align: middle;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }



    .center_space {
      width: 10.0mm;
      padding: 0mm;
      margin: 0px !important;
      box-sizing: border-box;
  //    border: 1px solid;
      border:none !important;
    }

    .pagebreak {
      break-after: page;
    }

    .nonprint { 
      display: none;
    }

    .onlyprint { 
      display: block;
    }
  }
</style>
-->